type FirebaseEnvKey =
  | "VITE_FIREBASE_API_KEY"
  | "VITE_FIREBASE_AUTH_DOMAIN"
  | "VITE_FIREBASE_PROJECT_ID"
  | "VITE_FIREBASE_STORAGE_BUCKET"
  | "VITE_FIREBASE_MESSAGING_SENDER_ID"
  | "VITE_FIREBASE_APP_ID"
  | "VITE_FIREBASE_MEASUREMENT_ID"
  | "VITE_FIREBASE_DATABASE_ID";

// Vite uses import.meta.env for environment variables (not process.env)
// For client-side variables, prefix with VITE_

/**
 * Firebase web config with environment-aware defaults.
 * Firebase web config values are public (not secrets), so we provide safe defaults here.
 */
const developmentFirebaseConfig = {
  // Development project
  apiKey: "AIzaSyA8yvD8JsPtV-TF4SU5d00tMubKX3zR2Ac",
  authDomain: "ezrecipebox-development.firebaseapp.com",
  projectId: "ezrecipebox-development",
  storageBucket: "ezrecipebox-development.firebasestorage.app",
  messagingSenderId: "1035269966086",
  appId: "1:1035269966086:web:2f0c1f44d74fd674713687",
  measurementId: "G-B97M82E8CD",
  databaseId: "(default)",
} as const;

const mainFirebaseConfig = {
  apiKey: "AIzaSyB8lb9kgJk1_MIRSMqkdoMSL6Ey0OJRviQ",
  authDomain: "ezrecipebox-main.firebaseapp.com",
  projectId: "ezrecipebox-main",
  storageBucket: "ezrecipebox-main.firebasestorage.app",
  messagingSenderId: "876646681719",
  appId: "1:876646681719:web:38b7ccae62e845a0908a72",
  measurementId: "G-26B3HWLCK4",
  databaseId: "(default)",
} as const;

type FirebaseWebConfigDefaults = { readonly [K in keyof typeof developmentFirebaseConfig]: string };

function pickDefaultFirebaseConfig(): FirebaseWebConfigDefaults {
  // Prefer runtime hostname when in browser.
  if (typeof window !== "undefined") {
    const host = window.location.hostname.toLowerCase();
    if (host === "localhost" || host === "127.0.0.1" || host.startsWith("dev.")) {
      return developmentFirebaseConfig;
    }
    return mainFirebaseConfig;
  }

  // Build: fall back to VITE_FIREBASE_ENVIRONMENT when available.
  const env = (import.meta.env.VITE_FIREBASE_ENVIRONMENT ?? "").toLowerCase();
  if (env === "main" || env === "production" || env === "prod") {
    return mainFirebaseConfig;
  }
  return developmentFirebaseConfig;
}

const defaultFirebaseConfig = pickDefaultFirebaseConfig();

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? defaultFirebaseConfig.apiKey,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? defaultFirebaseConfig.authDomain,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? defaultFirebaseConfig.projectId,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? defaultFirebaseConfig.storageBucket,
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? defaultFirebaseConfig.messagingSenderId,
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? defaultFirebaseConfig.appId,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? defaultFirebaseConfig.measurementId,
  databaseId: import.meta.env.VITE_FIREBASE_DATABASE_ID ?? defaultFirebaseConfig.databaseId,
} satisfies Record<string, string>;

const requiredEnvs: Array<[FirebaseEnvKey, string | undefined]> = [
  ["VITE_FIREBASE_API_KEY", firebaseConfig.apiKey],
  ["VITE_FIREBASE_AUTH_DOMAIN", firebaseConfig.authDomain],
  ["VITE_FIREBASE_PROJECT_ID", firebaseConfig.projectId],
  ["VITE_FIREBASE_STORAGE_BUCKET", firebaseConfig.storageBucket],
  ["VITE_FIREBASE_MESSAGING_SENDER_ID", firebaseConfig.messagingSenderId],
  ["VITE_FIREBASE_APP_ID", firebaseConfig.appId],
];

// Only validate in browser context (runtime)
if (typeof window !== "undefined") {
  for (const [envKey, value] of requiredEnvs) {
    if (!value) {
      throw new Error(`Missing environment variable: ${envKey}`);
    }
  }
}

export { firebaseConfig };

